module.exports=function(scope){ return ` <div class="dt-gnm-menu-support-button">
    <a class="icon-container">
      <div>
        ${scope.questionIcon}
        ${scope.caretIcon}
      </div>
    </a>
    <div class="items-container" hidden>
      <ul class="items-list" x-placement="bottom">
        <li class="arrow"><span></span></li>
        <li><a href="${scope.createTicketUrl}">Create Ticket</a></li>
        ${scope.chatUrl ? `<li><a href="${scope.chatUrl}">Chat with Support</a></li>` : ''}
        <li><a href="${scope.supportCenterUrl}">Support Center</a></li>
        <li><a href="${scope.knowledgeBaseUrl}">Knowledge Base</a></li>
        ${scope.feedbackUrl ? `<li><a href="${scope.feedbackUrl}">Submit Feedback</a></li>` : ''}
        ${scope.phoneNumber ? '<li role="separator" class="divider"></li>' : ''}
        ${scope.phoneNumber ? `<li><a href="${scope.phoneUrl}">${scope.phoneNumber}</a></li>` : ''}
        <li role="separator" class="divider"></li>
        <li><a href="${scope.statusUrl}">System Status</a></li>
      </ul>
    </div>
</div>
`};


// WEBPACK FOOTER //
// ./src/templates/global-menu-support.tpl.html